(() => {
  const sections = Array.from(document.querySelectorAll('.shopify-section'));
  if (!sections.length) return;

  sections.forEach((section, index) => {
    const images = Array.from(section.querySelectorAll('img'));
    const videos = Array.from(section.querySelectorAll('video'));

    if (index <= 1) {
      images.slice(0, 2).forEach((img) => {
        img.loading = 'eager';
        img.decoding = 'async';
        img.fetchPriority = 'high';
      });

      images.slice(2).forEach((img) => {
        img.loading = img.loading || 'lazy';
        img.decoding = 'async';
        img.fetchPriority = 'low';
      });
    } else {
      section.classList.add('tr-defer-section');

      images.forEach((img) => {
        img.loading = 'lazy';
        img.decoding = 'async';
        img.fetchPriority = 'low';
      });

      videos.forEach((video) => {
        video.preload = 'metadata';
        if (!video.hasAttribute('autoplay')) return;
        const rect = video.getBoundingClientRect();
        if (rect.top > window.innerHeight * 1.5) {
          video.removeAttribute('autoplay');
        }
      });
    }
  });
})();